<ng-container *ngIf="!isSBShell">
  <lv-notification></lv-notification>
</ng-container>
<div class="lv-on-load-spinner" *ngIf="isLoading">
  <mat-progress-spinner mode="indeterminate"
                        [diameter]="100"></mat-progress-spinner>
</div>
<ng-container *ngIf="initialised && uiModelObjectsObs$ | async as uiVorgang">
  <ng-container *ngIf="!uiVorgang?.UIArtefakt?.length">
    <div class="lv-main-column-sticky">
      <lv-meldung-box [meldungen]="uiVorgang.UIMeldung"></lv-meldung-box>
    </div>
  </ng-container>
  <ng-container *ngIf="!!uiVorgang?.UIArtefakt?.length">
    <lv-sticky-header class="lv-sticky-header-comp" [uiVorgang]="uiVorgang" [uiSpalte]="uiVorgangLayoutSpalte.SPALTE_LINKS"></lv-sticky-header>
    <div class="lv-antrag-content" [ngClass]="{'lv-grid-two-cols': !showLeftColumn}">
      <ng-container>
        <div class="lv-left-column" [ngClass]="{'lv-hide': !showLeftColumn}">
          <lv-ui-spalte [uiVorgang]="uiVorgang"
                        [uiSpalte]="uiVorgangLayoutSpalte.SPALTE_LINKS"></lv-ui-spalte>
        </div>
        <div class="lv-main-column">
          <div class="lv-main-column-sticky">
            <lv-meldung-box [meldungen]="uiVorgang.UIMeldung"></lv-meldung-box>
          </div>
          <div>
            <ng-container *ngIf="menu$ | async as menu">
              <lv-tab-view
                  *ngIf="uiLayout === uiLayoutEnum.TAB_MENU_NACH_GRUPPEN || uiLayout === uiLayoutEnum.NAVIGATION_MENU || uiLayout === uiLayoutEnum.ALLE_SEITEN"
                  [menu]="menu"
                  [uiLayout]="uiLayout"></lv-tab-view>
              <lv-accordion-view
                  *ngIf="uiLayout === uiLayoutEnum.AKKORDEON_MENU_NACH_GRUPPEN || uiLayout === uiLayoutEnum.AKKORDEON_MENU_NACH_SEITEN"
                  [menu]="menu" [uiLayout]="uiLayout"></lv-accordion-view>
            </ng-container>
          </div>
        </div>
        <div id="lv-antrag-column-right" class="lv-right-column" [ngClass]="{'lv-hide': !showRightColumn}">
          <lv-ui-spalte [uiVorgang]="uiVorgang"
                        [uiSpalte]="uiVorgangLayoutSpalte.SPALTE_RECHTS"></lv-ui-spalte>
        </div>
      </ng-container>
    </div>
  </ng-container>
</ng-container>
